import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { DEFAULT_HEADER_DATA } from "../../utils/state";
import { useTheme } from "../../contexts/ThemeContext";
import { HeaderSkeleton } from "./skeleton";
import defaultBanner from "./assets/banneras.jpg";
import { useAuth } from "../../contexts/AuthContext";

export const HeaderCourses = ({ moodle, lang }) => {
  const theme = useTheme();
  const { dictionary } = useAuth();
  const [state, setState] = React.useState(DEFAULT_HEADER_DATA);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!moodle.courses) return;

    if (moodle.courses.length > 0) {
      const timer = window.setTimeout(() => {
        setState({
          course: moodle.courses[0],
          noCoursesFound: false,
        });
      }, 700);
      return () => window.clearTimeout(timer);
    }

    setState({ course: true, noCoursesFound: true });
  }, [moodle.courses]);

  const handleNavigation = () => navigate(`/detailcourse/${state.course.id}`);
  const home = dictionary?.Home || {};

  return lang ? (
    <div className="courses-hero-wrap">
      <header
        className="courses-hero"
        style={{
          backgroundColor: theme.colors.background_banner_dark,
          "--hero-accent": theme.colors.primary_light,
          backgroundImage: `linear-gradient(90deg, rgba(8, 4, 55, .92) 0%, rgba(8, 4, 55, .72) 35%, rgba(8, 4, 55, .10) 70%, transparent 100%), url(${defaultBanner})`,
        }}
      >
        <div className="courses-hero__content">
          {!state.course ? (
            <HeaderSkeleton />
          ) : (
            <>
              <p className="courses-hero__eyebrow">{home.hero_eyebrow}</p>
              <h1 className="courses-hero__title font-russo">{home.hero_title}</h1>
              <p className="courses-hero__description">
                {home.hero_description}
              </p>
              {!state.noCoursesFound && (
                <button
                  type="button"
                  className="courses-hero__button"
                  style={{
                    backgroundColor:
                      theme.mode === "light"
                        ? theme.colors.primary_dark
                        : theme.colors.primary_light,
                    color: theme.colors.TextColorBannerBtn,
                  }}
                  onClick={handleNavigation}
                >
                  <span>{home.course_btn}</span>
                </button>
              )}
            </>
          )}
        </div>
      </header>
    </div>
  ) : null;
};
